import store from '@/store';

const { user } = store.getters;
export default {
    task_appoint: user.userCode + '_cainiao_appoint_record'
};
